import styled from 'styled-components';

export const StyledAccordionItem = styled.div`
  box-shadow: ${(p) => p.theme.shadows.bottom};
`;
